<app-nav></app-nav>
<section class="payment-status" *ngIf="!transactionFailure">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
    </div>
    <div class="seperator"></div>
    <div class="col download-document">
      <h4 class="text-center mt-3 thanks-title">Thank you for payment</h4>
    </div>
    <div class="col download-document">
      <h6 class="text-center mt-3 thanks-title">We have sent the policy to you over email.</h6>
    </div>

    <div class="col footer-strip text-center">
      <img
      src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
      class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>

<section class="payment-failure" *ngIf="transactionFailure">
  <div class="container">
    <div class="col text-center failure-error">

      <div class="insurer-image mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
          class="img-responsive" width="20%" alt="Error">
      </div>
      <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
      <p class="error-message">{{errorStatus}}</p>
      <p class="error-message">{{errorInternalMsg}}</p>
      <!-- <p>Transaction Id: 778W990</p> -->
    </div>
    <div class="col failure-reasons">
      <ul class="oval">
        <li>The Card CVV or Expiry Date might be wrong</li>
        <li>Your Bank networks might be down</li>
      </ul>
      <div class="text-center mt-4">
        <button class="btn btn-bordered-blue">Try Again</button>
      </div>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
